import React from "react";
import "../Styles/Overview.scss";

const Overview = () => {
  return (
    <div className="overview-wrapper">
      {/* Structural Stage for Overview Section - Monitor Screen Image is rendered by Main.js Outer Layer */}
      <div className="workstation-screen-stage" />
    </div>
  );
};

export default Overview;
